module.exports = __webpack_public_path__ + "img/Otp-guide-screen-5.a799e1a0.png";